import Cookies from '@comeon/tomcat-cookies';
import { createSelector } from 'reselect';
import { syncCookies } from '~/store/ducks/cookies.js';
import { requestApi, parseResponse } from '~/services/api.js';
import NS from './reducer-name.js';
import { MainContentLoadingStatus } from '../constants.js';
import { FETCH_CASINO_SUBMENU_GAMES_SUCCESS } from '~/components/casino-shared/subnavigation/ducks/action-names';
import { reportException } from '@comeon/error-reporter';
import { ErrorReporterDomain } from '~/components/error-handling/error-reporter-domain';

export const UPDATE_BRAND = '@komigen/mobile-frontend/brand/UPDATE_BRAND';
export const IFRAME_REQ_URL = '@komigen/mobile-frontend/brand/IFRAME_REQ_URL';
export const BANKID_DEPOSIT_LOGIN = '@komigen/mobile-frontend/brand/BANKID_DEPOSIT_LOGIN';
export const UPDATE_BANKID_DEPOSIT_RESULT = '@komigen/mobile-frontend/payment/UPDATE_BANKID_DEPOSIT_RESULT';
export const UPDATE_REGISTRATION_NORWAY = '@komigen/mobile-frontend/brand/UPDATE_REGISTRATION_NORWAY';

export const CHANGE_LAST_PRODUCT = '@komigen/mobile-frontend/brand/CHANGE_LAST_PRODUCT';

export const UPDATE_IS_DESKTOP_DEPENDENCIES = '@komigen/mobile-frontend/brand/UPDATE_IS_DESKTOP_DEPENDENCIES';

export const UPDATE_MAIN_CONTENT_LOADING = '@komigen/mobile-frontend/brand/UPDATE_MAIN_CONTENT_LOADING';

export const UPDATE_SHOW_NEW_HEADER = '@komigen/mobile-frontend/casino/UPDATE_SHOW_NEW_HEADER';

const host = '/';

export const selectIsDanishFranchise = state => state[NS].isDanishFranchise;
export const selectIsOntarioRegulatedFranchise = state => state[NS].isOntarioRegulatedFranchise;
export const selectIsGermanRegulatedFranchise = state => state[NS].isGermanRegulatedFranchise;
export const selectIsPolishFranchise = state => state[NS].isPolishFranchise;
export const selectIsNetherlandsRegulatedFranchise = state => state[NS].isNetherlandsRegulatedFranchise;
export const selectRegHeaderEnabled = state => state[NS].regHeaderEnabled;
export const selectSiteType = state => state[NS].siteType;
export const selectSiteCode = state => state[NS].siteCode;
export const selectEnableVIPLinkInProductNav = state => state[NS].enableVIPLinkInProductNav;
export const selectProducts = state => state[NS].products;
export const selectLocales = state => state[NS].locales;
export const selectLocale = createSelector(selectLocales, locales => locales.find(item => item.checked).locale);
export const selectIsoCodeForLocale = createSelector(
	selectLocales,
	locales => locales.find(item => item.checked).isoCode
);
export const selectIsRegularSiteType = createSelector(selectSiteType, siteType => siteType === 'REGULAR');
export const selectCurrentHrefLang = state => state[NS].currentHrefLang;
export const selectRiskProfileEnabled = state => state[NS].riskProfileEnabled;
export const selectPlayerActivityEnabled = state => state[NS].isGermanRegulatedFranchise;
export const selectRealityCheckScreenEnabled = state => state[NS].realityCheckScreenEnabled;
export const selectEnableRGExternalURL = state => state[NS].enableRGExternalUrl;
export const selectIsMentorRealTimeAlertsEnabled = state => state[NS].mentorRealTimeAlertsEnabled;

export const updateBrand = payload => {
	return dispatch => {
		if (payload.error) {
			reportException(new Error('Brand hydration error', { cause: payload.error }), {
				domain: ErrorReporterDomain.AUTHENTICATION
			});
		}

		return dispatch({
			type: UPDATE_BRAND,
			payload: {
				...payload
			}
		});
	};
};

export const externalIframeRequest = payload => ({
	type: IFRAME_REQ_URL,
	payload
});

export function bankIdDepositDetails(payload) {
	return dispatch =>
		dispatch({
			type: BANKID_DEPOSIT_LOGIN,
			payload
		});
}

export function updatebankIdDepositResult(payload) {
	return dispatch => {
		return dispatch({
			type: UPDATE_BANKID_DEPOSIT_RESULT,
			payload
		});
	};
}

export function updateRegistrationNorway(payload) {
	return dispatch => {
		return dispatch({
			type: UPDATE_REGISTRATION_NORWAY,
			payload
		});
	};
}

export function changeLastProduct(product) {
	Cookies.set('lastProduct', product, { path: '/' });

	return dispatch => {
		dispatch(syncCookies());
		return dispatch({
			type: CHANGE_LAST_PRODUCT,
			payload: {
				lastProduct: product
			}
		});
	};
}

export const updateMainContentLoading = payload => ({
	type: UPDATE_MAIN_CONTENT_LOADING,
	payload
});

export const setMainContentLoaded = () => ({
	type: UPDATE_MAIN_CONTENT_LOADING,
	payload: MainContentLoadingStatus.LOADED
});

export function hydrateBrand() {
	return async dispatch => {
		try {
			const url = `${host}rest/state/brand`;
			const response = parseResponse(await requestApi(url));
			return await dispatch(updateBrand(response));
		} catch (err) {
			reportException(new Error('Brand hydration error', { cause: err }), {
				domain: ErrorReporterDomain.AUTHENTICATION
			});
			return null;
		}
	};
}

// only used by desktop-state-manager
export const updateIsDesktopDependencies = isDesktop => ({
	type: UPDATE_IS_DESKTOP_DEPENDENCIES,
	payload: { isDesktop }
});
const initialState = {
	showGlobalMenu: false,
	mainContentLoading: MainContentLoadingStatus.LOADING,
	initialized: false
};
function reducer(stateTemp = initialState, { type, payload }) {
	// merges preloaded state with initial state since we get only partial state from server
	const state = stateTemp.initialized ? stateTemp : { ...initialState, ...stateTemp, initialized: true };

	switch (type) {
		case UPDATE_BRAND:
		case CHANGE_LAST_PRODUCT:
		case UPDATE_REGISTRATION_NORWAY:
			return { ...state, ...payload };
		case IFRAME_REQ_URL:
			return { ...state, ...payload };
		case BANKID_DEPOSIT_LOGIN:
			return { ...state, bankIdDepositDetails: payload };
		case UPDATE_BANKID_DEPOSIT_RESULT:
			return { ...state, bankIdDepositResult: payload };
		case UPDATE_MAIN_CONTENT_LOADING:
			return { ...state, mainContentLoading: payload };
		case UPDATE_IS_DESKTOP_DEPENDENCIES:
			return {
				...state,
				isDesktop: payload.isDesktop,
				regHeaderEnabled:
					state.isSwedishRegulatedFranchise ||
					(state.isDanishFranchise && !payload.isDesktop) ||
					state.isGermanRegulatedFranchise ||
					state.isOntarioRegulatedFranchise ||
					state.isNetherlandsRegulatedFranchise
			};
		// if backend sets the categorized field from the brand configuration this case will be redundant
		case FETCH_CASINO_SUBMENU_GAMES_SUCCESS:
			return {
				...state,
				casinoSubmenuItems: {
					...state.casinoSubmenuItems,
					[payload.isLive ? 'live_casino' : 'casino']: [
						...state.casinoSubmenuItems[payload.isLive ? 'live_casino' : 'casino'].map(
							submenu => payload.submenus.find(item => item.urlPath === submenu.urlPath) || submenu
						)
					]
				}
			};
		default:
			return state;
	}
}

export default reducer;
